import { momentLocalizer, Calendar } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import moment from "moment";
import { useEffect, useState } from "react";
import { Dialog, DialogTitle,IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { Close } from "@mui/icons-material";
// import { Col, Row } from "react-bootstrap";

const LeaveCalendar = (props) => {
  // const localizer = momentLocalizer(moment)
  const [showModal, setShowModal] = useState(false);
  const [list, setList] = useState([]);
  const [info, setInfo] = useState();

  const { dataToSearch, height, FetchDetails,view } = props;
  moment.locale("en-GB");
  const localizer = momentLocalizer(moment);

  const dataSummary = async () => {
    const resp = await FetchDetails(
      `api/request/leave/calendar?${dataToSearch}`
    );

    if (resp.status) {
      setList(
        resp.data?.data?.map((value) => ({
          title: value?.Resource?.names,
          allDay: true,
          start: new Date(value?.movedToStartDate ?? value?.startDate),
          end: new Date(value?.movedToEndDate ?? value?.endDate),
        }))
      );
    }
  };

  useEffect(() => {
    dataSummary()
    // if (dataToSearch) dataSummary();
  }, []);
  return (
    // <Row className={"justify-content-center p-3"}>
    //   <Col md={12} className=" bg-white p-3">
   <>
    <Calendar
      localizer={localizer}
      events={list}
      // step={60}
      views={{
        month: view?false:true,
        agenda: view?false:true,

      }}
      defaultDate={new Date()}
      // popup={true}
      // popupOffset={{x:100,y:1}}
      style={{ height: height ?? 500 }}
      startAccessor="start"
      endAccessor="end"
      onShowMore={(events, date) => {
        setInfo({events,date:moment(date).format('MMMM')})
        setShowModal(true);
      }}
    />
    <Dialog onClose={()=>setShowModal(false)} open={showModal} maxWidth="md" >
    <DialogTitle>Month of {info?.date}</DialogTitle>
    <IconButton
          aria-label="close"
          onClick={()=>setShowModal(false)}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <Close />
        </IconButton>

    <TableContainer>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
          <TableCell >#</TableCell>
            <TableCell >Name</TableCell>
            <TableCell >Start</TableCell>
            <TableCell >End</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {info?.events?.map((row,index) => (
            <TableRow key={index}>
              <TableCell>
                {index+1}
              </TableCell>
              <TableCell >{row?.title}</TableCell>
              <TableCell >{moment(row?.start).format('L')}</TableCell>
              <TableCell >{moment(row?.end).format('L')}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </Dialog>
   </>
    //   {/* </Col>
    // </Row> */}
  );
};
export default LeaveCalendar;
